import { numeralFormatter } from 'ns_libs/formatter';
import {
    IDispositionData, IOperatingInfo, IPermanentDebtInfo, IProFormaReturnsData,
} from 'views/ProFormaTable/types';
import { Format, RowValue } from '../../ExecutiveSummaryGenericTable/types';
import { ForecastMetricId } from '../../layout/metrics';
import { BlockResolver } from '../../layout/types';

const cell = (value: string | number, format: Format) => (): RowValue => ({ value, format });

export const proFormaForecastResolver = (
    disposition: IDispositionData | undefined,
    operatingInfo: IOperatingInfo,
    permanentDebtInfo: IPermanentDebtInfo | undefined,
    returnsData: IProFormaReturnsData | undefined,
): BlockResolver<ForecastMetricId> => {
    const coverageRatio = permanentDebtInfo?.debtServiceCoverageRatio;

    return {

        netSaleProceeds: cell(disposition?.netSaleProceeds?.amount ?? '-', 'currency'),
        permanentLoanPayoff: cell(permanentDebtInfo?.loanPayoffAmount ?? '-', 'currency'),
        equityProceedsFromSale: cell(returnsData?.totalEquityProceedFromCapitalEvents ?? '-', 'currency'),
        cashOnCashReturn: cell(permanentDebtInfo?.cashOnCashReturn ?? '-', 'percentage'),
        debtServiceCoverageRatio: cell(coverageRatio ? `${numeralFormatter(coverageRatio, '0,0.00')}x` : '-', 'none'),
        operatingExpenseRatio: cell(operatingInfo?.operatingExpenseRatio ?? '-', 'percentage'),
        breakevenOccupancy: cell(returnsData?.breakevenOccupancy ?? '-', 'percentage'),
    };
};
